<template>
  <div class="tw-flex tw-w-full tw-bg-blue-highlight tw-rounded-xl tw-p-4">
    <svg-vue
      icon="icons/warning"
      class="tw-w-8 tw-h-8 tw-text-blue tw-flex-shrink-0 -tw-mt-1 tw-mr-2"
    />
    <span><slot /></span>
  </div>
</template>
